module.exports = __webpack_public_path__ + "img/1.544eb0bc.png";